import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const links = [
    { label: "About", href: "#about" },
    { label: "Services", href: "#services" },
    { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 12);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const handleNav = (href) => {
        setOpen(false);
        const el = document.querySelector(href);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <header
            data-testid="site-navbar"
            className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
                scrolled
                    ? "bg-white/80 backdrop-blur-xl border-b border-slate-200/60"
                    : "bg-transparent border-b border-transparent"
            }`}
        >
            <nav className="max-w-7xl mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
                <a
                    href="#top"
                    onClick={(e) => {
                        e.preventDefault();
                        window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    data-testid="nav-brand-link"
                    className="flex items-center gap-2 font-display font-bold text-lg tracking-tight text-slate-900"
                >
                    <span className="inline-flex h-7 w-7 items-center justify-center rounded-md bg-blue-700 text-white text-xs font-bold">
                        N
                    </span>
                    NextGen Systems
                </a>

                <div className="hidden md:flex items-center gap-10">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            onClick={(e) => {
                                e.preventDefault();
                                handleNav(l.href);
                            }}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors"
                        >
                            {l.label}
                        </a>
                    ))}
                    <a
                        href="#contact"
                        onClick={(e) => {
                            e.preventDefault();
                            handleNav("#contact");
                        }}
                        data-testid="nav-cta-contact"
                        className="inline-flex items-center justify-center px-5 py-2.5 bg-blue-700 hover:bg-blue-800 text-white text-sm font-medium rounded-full transition-colors"
                    >
                        Contact Us
                    </a>
                </div>

                <button
                    type="button"
                    onClick={() => setOpen((v) => !v)}
                    data-testid="nav-mobile-toggle"
                    className="md:hidden inline-flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 text-slate-900 hover:bg-slate-50 transition-colors"
                    aria-label="Toggle menu"
                >
                    {open ? <X size={18} /> : <Menu size={18} />}
                </button>
            </nav>

            {open && (
                <div
                    data-testid="nav-mobile-menu"
                    className="md:hidden bg-white border-b border-slate-200"
                >
                    <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-4">
                        {links.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleNav(l.href);
                                }}
                                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                                className="text-base font-medium text-slate-700 hover:text-slate-900"
                            >
                                {l.label}
                            </a>
                        ))}
                        <a
                            href="#contact"
                            onClick={(e) => {
                                e.preventDefault();
                                handleNav("#contact");
                            }}
                            data-testid="nav-mobile-cta-contact"
                            className="inline-flex items-center justify-center px-5 py-3 bg-blue-700 text-white text-sm font-medium rounded-full"
                        >
                            Contact Us
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
};
